// third party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// ==============================|| SLICE - GDPR ||============================== //

const initialState = {
  error: null,
  loading: false,
  searchResults: [],
  userData: null,
  deleteResult: null,
  searchLoading: false,
};

const slice = createSlice({
  name: "gdpr",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.searchLoading = false;
    },

    // SET LOADING
    setLoading(state, action) {
      state.loading = action.payload;
    },

    // SET SEARCH LOADING
    setSearchLoading(state, action) {
      state.searchLoading = action.payload;
    },

    // SEARCH USERS SUCCESS
    searchUsersSuccess(state, action) {
      state.searchResults = action.payload;
      state.searchLoading = false;
    },

    // GET USER DATA SUCCESS
    getUserDataSuccess(state, action) {
      state.userData = action.payload;
      state.loading = false;
    },

    // DELETE USER DATA SUCCESS
    deleteUserDataSuccess(state, action) {
      state.deleteResult = action.payload;
      state.loading = false;
    },

    // CLEAR USER DATA
    clearUserData(state) {
      state.userData = null;
      state.deleteResult = null;
      state.searchResults = [];
      state.error = null;
    },
  },
});

// Reducer
export default slice.reducer;

// ==============================|| SLICE - GDPR ACTIONS ||============================== //

export function searchUsers(query) {
  return async () => {
    try {
      dispatch(slice.actions.setSearchLoading(true));
      const response = await axios.get(
        `/admin/gdpr/search?q=${encodeURIComponent(query)}`,
      );
      dispatch(slice.actions.searchUsersSuccess(response.data.users || []));
      return response.data.users || [];
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getGDPRUserData(userId, userEmail) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      // Support both system users (by ID) and booking-only users (by email)
      const params = userId
        ? `user_id=${userId}`
        : `user_email=${encodeURIComponent(userEmail)}`;
      const response = await axios.get(`/admin/gdpr/export?${params}`);
      dispatch(slice.actions.getUserDataSuccess(response.data.data));
      return response.data.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteGDPRUserData(userId, userEmail) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      // Support both system users (by ID) and booking-only users (by email)
      const data = userId ? { user_id: userId } : { user_email: userEmail };
      const response = await axios.post("/admin/gdpr/delete", data);
      dispatch(slice.actions.deleteUserDataSuccess(response.data.details));
      return response.data.details;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function confirmExportGDPRData(userId, userEmail) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      // Support both system users (by ID) and booking-only users (by email)
      const data = userId ? { user_id: userId } : { user_email: userEmail };
      const response = await axios.post("/admin/gdpr/export/confirm", data);
      dispatch(slice.actions.setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function clearGDPRData() {
  return async () => {
    dispatch(slice.actions.clearUserData());
  };
}
